module.exports = __webpack_public_path__ + "img/external-link.24d8a957.svg";